// react and js
import {
  Navigate,
  useRoutes,
} from "react-router-dom";
import { React } from "react";

// mui

// components

// hooks
import useAffiliateTracking from "./hooks/useAffiliateTracking";

// layouts
import Public from "./layouts/Public";

// pages
import ExpertAdvisorBuilder from "./pages/ExpertAdvisorBuilder/ExpertAdvisorBuilder";

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function Router() {
  // Affiliate tracking 
  useAffiliateTracking();
  // ######################################################
  // Router
  // ######################################################
  return useRoutes([
    {
      path: "/",
      element: <Navigate to="/expert-advisor-builder" />,
    },
    {
      path: "/",
      element: <Public />,
      children: [
        {
          path: "expert-advisor-builder",
          element: <ExpertAdvisorBuilder />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/expert-advisor-builder" replace />,
    },
  ]);
}
